export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-800 text-background-100">
      <div className="section-container py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-white text-lg"></i>
              </div>
              <span className="font-heading font-bold text-xl text-white">
                51吃瓜每日大赛
              </span>
            </div>
            <p className="text-background-300 text-sm leading-relaxed">
              全网领先的热点话题聚合平台，7×24小时不间断追踪娱乐、社会、网红、影视等各领域最新动态。做全网最快乐的吃瓜人，从这里开始。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">
              <a
                href="#cards"
                onClick={(e) => handleScroll(e, '#cards')}
                className="hover:text-primary-400 transition-colors cursor-pointer"
              >
                快速导航
              </a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '焦点专题', href: '#carousel' },
                { label: '吃瓜快讯', href: '#cards' },
                { label: '吃瓜热榜', href: '#ranking' },
                { label: '实时动态', href: '#updates' },
                { label: '话题广场', href: '#topics' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleScroll(e, item.href)}
                    className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">热门话题</h4>
            <ul className="space-y-2.5">
              {[
                { label: '娱乐圈大瓜', href: '#index' },
                { label: '社会热点', href: '#index' },
                { label: '情感八卦', href: '#index' },
                { label: '网红动态', href: '#index' },
                { label: '网络热梗', href: '#index' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => handleScroll(e, item.href)}
                    className="text-background-300 hover:text-primary-400 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-white mb-4">合作伙伴</h4>
            <p className="text-background-300 text-sm leading-relaxed">
              合作品牌持续入驻中，敬请期待。
            </p>
            <a
              href="#contact"
              onClick={(e) => handleScroll(e, '#contact')}
              className="inline-flex items-center gap-1.5 text-primary-400 hover:text-primary-300 text-sm mt-4 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              商务合作
            </a>
          </div>
        </div>

        <div className="border-t border-background-400/20 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-400 text-xs md:text-sm text-center sm:text-left">
            &copy; 2026 51吃瓜每日大赛 · 51今日吃瓜 · 51每日吃瓜 · 51吃瓜网今日吃瓜 | 24小时吃瓜动态 · 每日吃瓜快讯 · 实时更新大瓜 · 今日热点话题
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => handleScroll(e, '#hero')} className="text-background-400 hover:text-primary-400 text-sm transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}